import React from "react";
import { Box, IconButton, Menu, MenuItem, Typography, Divider } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

const WatchlistBookmark = ({
  formattedWatchlists,
  token,
  exchange,
  onAdd,
  onRemove,
  anchorEl,
  setAnchorEl,
}) => {
  const theme = useTheme();

  if (!formattedWatchlists || formattedWatchlists.length === 0) return null;

  const isInAnyWatchlist = formattedWatchlists?.some((watchlist) =>
    watchlist.instruments?.some(
      (instr) => String(instr.token) === String(token) && String(instr.exchange) === String(exchange)
    )
  );

  return (
    <Box sx={{ position: 'relative' }}>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          p: 0.25,
          minWidth: 32,
          height: 28,
          backgroundColor: 'background.paper',
          '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.1) },
        }}
      >
        {isInAnyWatchlist ? (
          <BookmarkIcon fontSize="small" sx={{ color: theme.palette.success.main }} />
        ) : (
          <BookmarkBorderIcon fontSize="small" sx={{ color: theme.palette.text.secondary }} />
        )}
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ sx: { maxHeight: 300, width: 250, mt: 1, boxShadow: theme.shadows[4] } }}
      >
        <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 600 }}>
          {isInAnyWatchlist ? 'Remove from Marketwatch' : 'Add to Marketwatch'}
        </Typography>
        <Divider />
        {formattedWatchlists?.map((watchlist, index) => {
          const isInWatchlist = watchlist.instruments?.some(
            (instr) => String(instr.token) === String(token) && String(instr.exchange) === String(exchange)
          );

          return (
            <MenuItem
              key={watchlist.id}
              onClick={() => {
                if (isInWatchlist) {
                  onRemove(watchlist, index);
                } else {
                  onAdd(watchlist, index);
                }
                setAnchorEl(null);
              }}
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1 }}
            >
              <Typography variant="body2">{watchlist.name}</Typography>
              {isInWatchlist && (
                <BookmarkIcon fontSize="small" sx={{ color: theme.palette.success.main, ml: 1 }} />
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

export default WatchlistBookmark;


